import * as moment from "moment"
import React from "react"
import { Link } from "react-router-dom"
import { Badge } from "reactstrap"

const formateDate = (date, format) => {
  const dateFormat = format ? format : "HH:mm:ss";
  const date1 = moment(date).format(dateFormat)
  return date1.toString()
}
const toLowerCase1 = str => {
  return str === "" || str === undefined ? "" : str.toLowerCase()
}

const OrderId = cell => {
  return (
    <Link to="#" className="text-body fw-bold">
      {cell.value ? cell.value : ""}
    </Link>
  )
}

const StartDateTime = cell => {
  return cell ? formateDate(cell) : ""
}
const StartTime = cell => {
  
  return cell ? formateDate(cell.cell.value) : ""
}

const EndtTime = cell => {
  return cell ? formateDate(cell) : ""
}
const EndTimess = cell => {
  return cell ? formateDate(cell.cell.value) : ""
}


const ProjectName = cell => {
  return cell.value ? cell.value : ""
}

const ClientName = cell => {
  return cell.value ? cell.value : ""
}

const PrivateHrs = cell => {
  return cell.value ? cell.value : ""
}
const ActiveHrs = cell => {
  return cell.value ? cell.value : ""
}

const IdleHrs = cell => {
  return cell.value ? cell.value : ""
}

const ManualHrs = cell => {
  return cell.value ? cell.value : ""
}

const BrkHrs = cell => {
  return cell.value ? cell.value : ""
}

const TotalHrs = cell => {
  return cell.value ? cell.value : ""
}

const Date = cell => {
  return cell.value ? cell.value : ""
}

const Total = cell => {
  return cell.value ? cell.value : ""
}

const ReportInsertedTime = cell => {
  // Supports both calling conventions:
  //  - react-bootstrap-table passes the raw field value as `cell`
  //  - react-table passes a props object exposing the value on `cell.value`
  // Guard against null/undefined so rows with no reportInsertedTime don't crash.
  const value = cell && typeof cell === "object" ? cell.value : cell
  return value ? formateDate(value, "YYYY-MM-DD HH:mm:ss") : ""
}

const PaymentStatus = cell => {
  return (
    <Badge
      className={
        "font-size-12 badge-soft-" +
        (cell.value === "Paid"
          ? "success"
          : "danger" && cell.value === "Refund"
          ? "warning"
          : "success")
      }
      pill
    >
      Active
    </Badge>
  )
}

const PaymentMethod = cell => {
  return (
    <span>
      <i
        className={
          cell.value === "Paypal"
            ? "fab fa-cc-paypal me-1"
            : "" || cell.value === "COD"
            ? "fab fas fa-money-bill-alt me-1"
            : "" || cell.value === "Mastercard"
            ? "fab fa-cc-mastercard me-1"
            : "" || cell.value === "Visa"
            ? "fab fa-cc-visa me-1"
            : ""
        }
      />{" "}
      {cell.value}
    </span>
  )
}
export {
  OrderId,
  StartDateTime,
  EndtTime,
  ProjectName,
  ClientName,
  PrivateHrs,
  IdleHrs,
  ManualHrs,
  BrkHrs,
  TotalHrs,
  Date,
  Total,
  PaymentStatus,
  PaymentMethod,
  ActiveHrs,
  EndTimess,
  StartTime,
  ReportInsertedTime

}
